<template>
  <div class="clients-actions">
    <div class="listing-title">{{ $t(titleAllOrFiltered) }}</div>
    <div class="search">
      <tol-type-ahead
        :search-params="{
          url: '/clients',
          searchKeys: ['searchParam'],
          urlParams: {
            recordsPerPage: clientsRecordsPerpage,
            offset: clientsRecordsOffset,
            sortBy: clientsSortField,
            sortDirection: clientsSortDirection,
            clientsFilterPreference,
            clientsTypeFilterPreference
          }
        }"
        :results-in-dropdown="false"
        :allow-empty-search="true"
        @filtered="onFiltered($event)"
      >
      </tol-type-ahead>
    </div>
    <div class="action-btns">
      <router-link to="/clients/create">
        <TolAltButton icon-name="plus" :label="$t('clientContacts.listing.actions.new')" />
      </router-link>
      <TolAltButton
        v-click-outside="() => (displayExportOptions = false)"
        icon-name="file-excel"
        :label="$t('clientContacts.listing.actions.exportToExcel')"
        @click="displayExportOptions = !displayExportOptions"
      />
      <Dropdown
        v-if="displayExportOptions"
        :menu-items="[
          { label: $t('clientContacts.listing.actions.exportAll') },
          { label: $t('clientContacts.listing.actions.exportPage') }
        ]"
        class="dropdown-menu-right dropdown-display"
        @optionClicked="onMenuOptionSelected($event)"
      />
    </div>
  </div>
</template>
<script>
import TolAltButton from '@/app/components/TolAltButton';
import TolTypeAhead from '@/app/components/TolTypeAhead';
import {
  ClientsListingGetters,
  ClientsListingActions
} from '@/app/features/clients/features/clients-listing/clients-listing.keys';
import Dropdown from '@/app/components/Dropdown';
import vClickOutside from 'v-click-outside';
import { mapGetters } from 'vuex';
export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {
    Dropdown,
    TolTypeAhead,
    TolAltButton
  },
  props: {
    titleAllOrFiltered: {
      type: String,
      default: 'clients.listing.all'
    }
  },
  data() {
    return {
      displayExportOptions: false
    };
  },
  computed: {
    ...mapGetters([
      ClientsListingGetters.ClientsRecordsPerPage,
      ClientsListingGetters.ClientsRecordsOffset,
      ClientsListingGetters.ClientsRecordsCount,
      ClientsListingGetters.ClientsSortField,
      ClientsListingGetters.ClientsSortDirection,
      ClientsListingGetters.ClientsFilterPreference,
      ClientsListingGetters.ClientsTypeFilterPreference
    ])
  },

  methods: {
    exportAsExcel() {
      this.$store.dispatch(ClientsListingActions.DownloadClientsListAsExcel);
    },
    onMenuOptionSelected(event) {
      this.displayExportOptions = false;
      this.$store.dispatch(ClientsListingActions.DownloadClientsListAsExcel, event.menuOption);
    },
    onFiltered(results) {
      this.$store.dispatch(ClientsListingActions.UpdateClientsList, results);
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../../../../../styles/colors.scss';
@import '../../../../../styles/variables.scss';

.clients-actions {
  display: flex;
  background-color: $background-level-2;
  padding: 60px;
  align-items: center;
  .search-container {
    margin-right: 3px;
  }

  .listing-title {
    color: $text-color-dark;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: -0.24px;
    line-height: 28px;
    flex-basis: 25%;
  }
  .action-btns {
    display: flex;
    position: relative;
    margin-left: auto;

    justify-content: flex-end;
    flex-basis: 25%;
    a {
      text-decoration: none;
      color: inherit;
    }

    .wrapper {
      margin-right: 3px;
    }
  }
  .dropdown-display {
    border-right: 1px solid $row-border;
    border-left: 1px solid $row-border;
    border-bottom: 1px solid $row-border;
    font-weight: bold;
  }

  .search {
    display: flex;
    flex-basis: 50%;
    .search-container {
      flex: 1;
    }
  }
}
</style>
